import { styled } from '@mui/system';
import { OutlinedInput, Typography, FormControl } from '@mui/material';
import Search from '@mui/icons-material/Search';

export const SearchContainer = styled(FormControl)(() => ({
  position: 'relative'
}));

export const StyledInput = styled(OutlinedInput)(() => ({
  boxShadow: '0px 1px 2px rgb(0 0 0 / 16%), 0px 2px 4px rgb(0 0 0 / 12%), 0px 1px 8px rgb(0 0 0 / 10%)',
  borderRadius: 8,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.23) !important',
    borderWidth: 2
  }
}));

export const SearchIcon = styled(Search)(() => ({
  color: '#757575'
}));

export const SearchResultContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  position: 'absolute',
  zIndex: 1101,
  width: '100%',
  maxHeight: 300,
  top: 'calc(100% + 8px)',
  left: 0,
  right: 0,
  margin: 0,
  padding: 0,
  overflow: 'auto',
  overflowX: 'hidden',
  backgroundColor: '#fff',
  boxShadow: '0px 1px 2px rgb(0 0 0 / 16%), 0px 2px 4px rgb(0 0 0 / 12%), 0px 1px 8px rgb(0 0 0 / 10%)',
  borderRadius: theme.spacing(1),
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  }
}));

export const ResultItem = styled(Typography)(({ theme }) => ({
  width: '100%',
  margin: 0,
  padding: theme.spacing(1, 3),
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 0, 0, 0.04)'
  }
}));

export const StatusMessage = styled('div')(({ theme }) => ({
  position: 'absolute',
  fontSize: 14,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: 40,
  bottom: -42,
  left: 0,
  background: '#fff',
  zIndex: 3,
  padding: theme.spacing(1, 3),
  boxShadow: '0px 1px 2px rgb(0 0 0 / 16%), 0px 2px 4px rgb(0 0 0 / 12%), 0px 1px 8px rgb(0 0 0 / 10%)',
  borderRadius: theme.spacing(0.5)
}));

export const Preloader = styled('div')(() => ({
  position: 'relative',
  marginRight: 12,
  display: 'flex'
}));
